const activities = [
    { text: "Se emitió el certificado",  bold: "CER-00128" },
    { text: "Se validó el certificado",  bold: "CER-00126" },
    { text: "Se rechazó el certificado", bold: "CER-00120" },
    { text: "Se consultó el expediente de", bold: "Juan Pérez" },
];

function FuncionarioActividad() {
    return (
        <div className="rounded-[var(--radius-md)] bg-surface p-[22px] shadow-[0_8px_20px_rgba(0,0,0,0.05)]">
            <h3 className="mb-5 text-lg font-semibold text-primary">Actividad Reciente</h3>

            <ul className="m-0 list-none p-0">
                {activities.map((item, i) => (
                    <li
                        key={i}
                        className="mb-[15px] rounded-[10px] border-l-4 border-l-primary bg-bg p-[15px] leading-[1.5] transition-all duration-250 hover:translate-x-[5px] hover:bg-bg-subtle"
                    >
                        {item.text} <strong className="text-primary">{item.bold}</strong>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default FuncionarioActividad;
